import {NgModule} from '@angular/core';
import {SafePipe} from '@caroo/shared/pipes/safe/safe.pipe';

@NgModule({
	declarations: [SafePipe],
	exports: [SafePipe]
})
export class SafeModule {}
